import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["answer"]

  toggle(event) {
    const button = event.currentTarget
    const answer = button.nextElementSibling
    const icon = button.querySelector("[data-faq-icon]")
    const isHidden = answer.classList.contains("hidden")

    if (isHidden) {
      answer.classList.remove("hidden")
      button.setAttribute("aria-expanded", "true")
      if (icon) icon.classList.add("rotate-180")
    } else {
      answer.classList.add("hidden")
      button.setAttribute("aria-expanded", "false")
      if (icon) icon.classList.remove("rotate-180")
    }
  }
}
